<dx-scroll-view [height]="height">

  <div class="leading-7 text-base mt-4 mb-6 p-2">
    <div><span class="font-bold">Période:</span> {{request.from | date}} - {{request.to | date}}</div>
    <div><span class="font-bold">Domaines:</span> {{filterDomains()}}</div>
  </div>
  <hr/>
  <app-material-park-data
    [index]="1"
    (initialized)="subReportInitialized($event)"
    [store]="store"></app-material-park-data>
  <app-material-usage
    [index]="2"
    (initialized)="subReportInitialized($event)"
    [store]="store"></app-material-usage>
<!--  <app-material-usage-campaign
    [index]="3"
    [store]="store"></app-material-usage-campaign>-->
  <app-progression-speed
    [index]="3"
    (initialized)="subReportInitialized($event)"
    [store]="store"></app-progression-speed>
<!--  <app-throughput
    [index]="5"
    [store]="store"></app-throughput>-->
<!--  <app-usage-optimization
    [index]="6"
    [store]="store"></app-usage-optimization>-->
<!--  <app-operations-synthesis
    [index]="7"
    [store]="store"></app-operations-synthesis>-->
  <app-operations-progress
    [index]="4"
    (initialized)="subReportInitialized($event)"
    [store]="store"></app-operations-progress>
  <app-fuel-consumption
    [index]="5"
    (initialized)="subReportInitialized($event)"
    [store]="store"></app-fuel-consumption>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
</dx-scroll-view>

<dx-popup
  [width]="500"
  [height]="450"
  [showTitle]="false"
  class="fields-intervention-report-popup-2"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [elementAttr]="{ class: 'fields-intervention-report-popup-2' }"
  [(visible)]="isFilterVisible">

  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Fermer',
            onClick: close
        }">
  </dxi-toolbar-item>

  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'OK',
            onClick: applyFilter
        }">
  </dxi-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <lib-domains-selector
      [title]="'X'"
      [domains]="domains"
      [(value)]="filter.domains"></lib-domains-selector>
  </div>
</dx-popup>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.2)"
  [(visible)]="isLoading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
